import React from 'react';

import { Checkbox as CheckboxAtom } from '../../../Atoms';
const Checkbox = ({ options, setMultipleValue, multiValue }) => {
  const handleChange = ({ target: { checked, id } }) => {
    const values = [...multiValue];
    if (checked) {
      setMultipleValue([...multiValue, id]);
    } else {
      const index = values.indexOf(id);
      values.splice(index, 1);
      setMultipleValue(values);
    }
  };

  return (
    <div>
      {options.map((option, index) => (
        <CheckboxAtom
          key={index}
          title={option.text}
          checked={multiValue.includes(option.id.toString())}
          value={option.id}
          onChange={handleChange}
        />
      ))}
    </div>
  );
};

export default Checkbox;
